import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, Router, RouterLink } from '@angular/router';
import { ActionReportModel, extractDefaultStoreId, extractNumber, HxProductService, HxReportService, isoDate, toRouterQueryParams } from 'hx-services';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { HxDateSelectComponent, HxStoreSelectComponent } from 'hx-component';
import { FormsModule } from '@angular/forms';
import { NgClass, NgFor } from '@angular/common';
import { NgbTooltip } from '@ng-bootstrap/ng-bootstrap';
import { TranslocoPipe } from '@jsverse/transloco';

/**
 * Report with income-outcome report, money-report, order's actions, close working day
 */
@Component({
    selector: 'app-order-status-report.m-grid__item.m-grid__item--fluid.m-wrapper',
    templateUrl: './order-status-report.component.html',
    styleUrls: ['./order-status-report.component.css'],
    imports: [HxStoreSelectComponent, FormsModule, HxDateSelectComponent, NgFor, NgClass, NgbTooltip, RouterLink, TranslocoPipe]
})
export class OrderStatusReportComponent implements OnInit, OnDestroy {
  statusReportList: ActionReportModel[] = [];
  params: { date?: string, storeId?: number } = {};
  private $destroyed = new Subject<void>();

  constructor(
    private reportService: HxReportService,
    private productService: HxProductService,
    private router: Router,
    private aRoute: ActivatedRoute,
  ) {
  }

  ngOnInit() {
    this.aRoute.queryParamMap.pipe(takeUntil(this.$destroyed)).subscribe(paramMap => {
      this.params.date = paramMap.get('date') ?? isoDate(Date.now());
      this.params.storeId = extractNumber('storeId', paramMap) ?? extractDefaultStoreId();
      if (this.params.storeId) {
        this.loadReport();
      } else {
        this.statusReportList = [];
      }
    });
  }

  ngOnDestroy(): void {
    this.$destroyed.next();
    this.$destroyed.complete();
  }

  navigate() {
    this.router.navigate(['./'], {
      queryParams: toRouterQueryParams(this.params),
      relativeTo: this.aRoute
    });
  }

  async loadReport() {
    this.statusReportList = [];
    this.statusReportList = await this.reportService.getAction(this.params);
  }
}
